module.exports = __webpack_public_path__ + "static/media/eat-and-run.69d806f6.jpg";